import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhonePipe } from './phone.pipe';
import { NoNamePipe } from './no-name.pipe';



@NgModule({
  declarations: [
    PhonePipe,
    NoNamePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PhonePipe,
    NoNamePipe
  ]
})
export class AppPipesModule { }
